import * as Sentry from '@sentry/react';

const parseBoolean = (value, fallback) => {
  if (typeof value !== 'string') {
    return fallback;
  }

  const normalized = value.trim().toLowerCase();

  if (['1', 'true', 'yes', 'on'].includes(normalized)) {
    return true;
  }

  if (['0', 'false', 'no', 'off'].includes(normalized)) {
    return false;
  }

  return fallback;
};

const parseSampleRate = (value, fallback) => {
  const parsed = Number(value);

  if (!Number.isFinite(parsed)) {
    return fallback;
  }

  return Math.min(1, Math.max(0, parsed));
};

export const initSentry = () => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;

  if (!dsn) {
    if (process.env.NODE_ENV === 'development') {
      console.info('Sentry disabled: REACT_APP_SENTRY_DSN is not set.');
    }

    return;
  }

  const tracePropagationTargets = ['localhost'];

  if (process.env.REACT_APP_SERVER_URL) {
    tracePropagationTargets.push(process.env.REACT_APP_SERVER_URL);
  }

  Sentry.init({
    dsn,
    sendDefaultPii: parseBoolean(process.env.REACT_APP_SENTRY_SEND_DEFAULT_PII, true),
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: parseSampleRate(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE, 1.0),
    tracePropagationTargets,
    replaysSessionSampleRate: parseSampleRate(
      process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
      0.1
    ),
    replaysOnErrorSampleRate: parseSampleRate(
      process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
      1.0
    ),
    enableLogs: parseBoolean(process.env.REACT_APP_SENTRY_ENABLE_LOGS, true),
    environment: process.env.REACT_APP_ENV || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE || process.env.REACT_APP_VERSION,
    debug: parseBoolean(process.env.REACT_APP_SENTRY_DEBUG, false),
  });
};
